/**
 * Czech plural forms.
 *
 * Czech has three: one (1), few (2–4), many (0, 5+). Picking the wrong one
 * reads as broken machine translation on a site whose entire argument is that
 * it was built carefully, so it is worth the twelve lines.
 *
 * `Intl.PluralRules` knows these categories, so the rule itself is not
 * hand-rolled — only the mapping from category to word.
 */
const rules = new Intl.PluralRules('cs-CZ');

export interface CzechForms {
  /** 1 podnět */
  one: string;
  /** 2 podněty */
  few: string;
  /** 5 podnětů */
  many: string;
}

export function plural(count: number, forms: CzechForms): string {
  switch (rules.select(count)) {
    case 'one':
      return forms.one;
    case 'few':
      return forms.few;
    default:
      // Czech also has a "many" category for decimals (1,5 podnětu); counts
      // here are always integers, so `other` and `many` collapse to the same
      // genitive plural.
      return forms.many;
  }
}

export const PODNET: CzechForms = { one: 'podnět', few: 'podněty', many: 'podnětů' };
export const PODPORA: CzechForms = { one: 'podpora', few: 'podpory', many: 'podpor' };

/** "15 podnětů" */
export function countWith(count: number, forms: CzechForms): string {
  return `${count} ${plural(count, forms)}`;
}
